/* eslint-disable import/no-anonymous-default-export */
import { notification } from "antd";
import moment from "moment";
import React, { useContext, useEffect } from "react";
import AppStateContext from '../contexts/AppStateContext';

export default (props:{children:React.ReactNode}) => {
    const appStateContext = useContext(AppStateContext);
    
    // useEffect(()=>{
    //     if (appStateContext?.UltimaCargaInfracciones && moment().diff(appStateContext!.UltimaCargaInfracciones) <= 10000)
    //     {
    //         notification.success({message:"Infracciones cargadas correctamente",placement:'bottomRight'});
    //     }
    // },[appStateContext?.UltimaCargaInfracciones]);

    // useEffect(()=>{
    //     if (appStateContext?.CargandoInfracciones)
    //     {
    //         notification.info({message:"Cargando infracciones...",placement:'bottomRight'})
    //     }
    // },[appStateContext?.CargandoInfracciones]);

    return (
        <>
            {props.children}
            
        </>
    );

};